import axios from "axios";

const ENV_BASE = process.env.REACT_APP_BACKEND_URL || "";

// Resolve the API base URL safely in any environment:
// • Same-origin (production custom domain, preview, dev with proxy) → use
//   relative "/api" so cookies + CORS just work.
// • Different-host (legacy preview where REACT_APP_BACKEND_URL points to a
//   distinct hostname matching the page host) → use the full URL.
// This prevents the "steeping…" infinite-loading bug that occurs when the
// deployed bundle was built pointing at host A but is served from host B
// (e.g., bundle baked with tea-time-site-1.emergent.host but loaded on
// thetealist.com — third-party cookie policies silently break the call).
function resolveApi() {
  if (typeof window !== "undefined" && ENV_BASE) {
    try {
      const envHost = new URL(ENV_BASE).host;
      if (envHost !== window.location.host) return "/api";
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.warn("[api] REACT_APP_BACKEND_URL is malformed; using it as-is", err);
    }
  }
  return `${ENV_BASE}/api`;
}

export const API = resolveApi();

/**
 * Absolute API URL — needed when the URL has to be valid OUTSIDE the
 * browser, e.g., when handed to Facebook/Twitter/LinkedIn share dialogs
 * which crawl the URL from their own servers and cannot resolve relative
 * paths. Always falls back to the current origin if no env URL is set.
 */
export function absoluteApi() {
  if (typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }
  return `${ENV_BASE}/api`;
}

// Auth uses httpOnly cookies set by the backend on login.
// withCredentials ensures cookies are sent on every request.
export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
